import { useState, useEffect, useContext } from "react";
import { Autocomplete, TextField, Typography, Grid, Button } from "@mui/material";
import { reducerContext } from "../../../../contextApi's/contextApi's";
import snackError from "../../../../helpers/snackError";

import { httpRequest } from "../../../../ui-utils/api";
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig";
import axios from "axios";

const TagMapping = () => {
    const { state, dispatch } = useContext(reducerContext)
    const { faqTags, faqs } = state

    const [selectedTag, setSelectedTag] = useState(null)
    const [selectedFaq, setSelectedFaq] = useState(null)
    const [errors, setErrors] = useState({})


    useEffect(() => {

        (async () => {
            try {

                const result = await axios.get(`${backendHosts.ADMIN}${apiUrl.faqTags}`)
                // const result = await httpRequest({
                //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqTags}`,
                //     method: "get",
                //     instance: "instanceOne",
                // })

                if (result.data?.status == 200) {
                    dispatch({
                        type: 'SET_FAQ_TAGS',
                        payload: result.data?.faqResults,
                    })
                }
            } catch (error) {
                console.log("Error while fetching tags list API", error)
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: error.error })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            }
        })()

    }, []);

    useEffect(() => {

        (async () => {
            try {

                const result = await axios.get(`${backendHosts.ADMIN}${apiUrl.faqs}`)
                // const result = await httpRequest({
                //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqs}`,
                //     method: "get",
                //     instance: "instanceOne",
                // })

                if (result.data?.status == 200) {
                    dispatch({
                        type: 'SET_FAQS',
                        payload: result.data?.faqResults,
                    })
                }
            } catch (error) {
                console.log("Error while fetching faqs list API", error)
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: error.error })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            }
        })()

    }, [])

    const validateTagFields = () => {
        const newErrors = {};

        if (!selectedTag || !selectedTag.id) {
            newErrors.tag = "Tag is required";
        }

        if (!selectedFaq || !selectedFaq.id) {
            newErrors.faq = "Faq is required";
        }

        return newErrors;
    };


    const handleCreateTagMap = async () => {
        const validationErrors = validateTagFields()
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = {
            faq_id: selectedFaq.id,
            tag_id: selectedTag.id,
        }

        try {

            const createdTagMap = await axios.post(`${backendHosts.ADMIN}${apiUrl.faqTagMap}`,payload)
            // const createdTagMap = await httpRequest({
            //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqTagMap}`,
            //     method: "post",
            //     instance: "instanceOne",
            //     requestBody: payload,
            // })

            if (createdTagMap.data?.status === 201) {

                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: createdTagMap.data?.message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })

                setSelectedTag('')
                setSelectedFaq('')
                setErrors({})
            }

        } catch (error) {
            console.log("Error while mapping faq tags:", error)
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: error.error })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        }

    }

    return (
        <>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                Tag Mapping:
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={5}>
                    <Autocomplete
                        fullWidth
                        options={faqTags}
                        getOptionLabel={(option) => option.tag_name || ""}
                        value={selectedTag}
                        onChange={(event, newValue) => setSelectedTag(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Tag" variant="outlined" autoComplete="new-password" error={!!errors.tag}
                                helperText={errors.tag} />
                        )}
                    />
                </Grid>

                <Grid item xs={12} md={5}>
                    <Autocomplete
                        fullWidth
                        options={faqs}
                        getOptionLabel={(option) => option.question || ""}
                        value={selectedFaq}
                        onChange={(event, newValue) => setSelectedFaq(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Faq" variant="outlined" autoComplete="new-password" error={!!errors.faq} helperText={errors.faq} />
                        )}
                    />
                </Grid>
            </Grid>

            <Button onClick={handleCreateTagMap} variant="contained" color="primary" sx={{ mt: 2, mb: 3 }}>
                Map Tags
            </Button>
        </>
    );

}

export default TagMapping
